module.exports = __webpack_public_path__ + "img/menu_3.17de1016.png";